module.exports = __webpack_public_path__ + "static/img/8.329bcae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/8.png
// module id = VOw6
// module chunks = 0